import { render, staticRenderFns } from "./authorizationLogin.vue?vue&type=template&id=44cc53d6&"
import script from "./authorizationLogin.vue?vue&type=script&lang=js&"
export * from "./authorizationLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports